'use client'

import React, { useState } from 'react'
import { Faqs } from '@/services/dataTypes'
import { ChevronDown, HelpCircle } from 'lucide-react'

interface Props {
    faq: Faqs
    index: number
}

const MerchantFaqsAccordion = ({ faq, index }: Props) => {
    const [open, setOpen] = useState(index === 0)

    return (
        <div className="group bg-white rounded-2xl border border-slate-100 overflow-hidden transition-all duration-300 hover:border-[#00d69f]/40 shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
            <button
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-slate-50/50 transition-all duration-200 cursor-pointer"
            >
                <div className="flex items-center gap-3.5">
                    <div className={`w-7 h-7 rounded-xl flex items-center justify-center transition-all duration-300 ${open ? 'bg-[#071822] text-white shadow-xs' : 'bg-slate-50 text-[#00a87a] border border-slate-100'
                        }`}>
                        <HelpCircle size={13} />
                    </div>
                    <span className="text-xs sm:text-sm font-bold text-slate-900">
                        {faq.question}
                    </span>
                </div>
                <ChevronDown
                    size={15}
                    className={`text-slate-400 group-hover:text-slate-900 transition-all duration-300 shrink-0 ml-3 ${open ? 'rotate-180 text-slate-900' : ''}`}
                />
            </button>

            {open && (
                <div className="px-5 pb-5 pt-1 text-xs sm:text-sm text-slate-800 border-t border-slate-50 leading-relaxed font-normal transition-all duration-200">
                    {faq.answer}
                </div>
            )}
        </div>
    )
}

export default MerchantFaqsAccordion